import { useContext, useEffect, useRef, useState } from "react";
import Axios from "axios";
import Select from 'react-select';
import { Accordion, Card, Col, Form } from "react-bootstrap";
import InputControlMulti from "../../../components/inputs/InputControlMulti";
import InputDate from "../../../components/inputs/InputDate";
import DashboardContext from "../../../Context";
/**
 * این کامپوننت برای نمایش دارپ دان سفارشات دوره ای است در بخش ثبت سفارش استفاده شده است
 */
export default function FormPreiod({ datapreiod, handelPreiodForm, defaultValue }) {

    const { authentication, urldashboard, handelloding, handelerrors } = useContext(DashboardContext);


    const selectInputRefweekType = useRef();

    const selectInputRefdayType = useRef();


    const handelValue = (name, value) => {
        switch (name) {
            case 'endWork':
                handelPreiodForm({ ...datapreiod, endWork: value })
                break;
            case 'periodDayOfWeeks':
                handelPreiodForm({ ...datapreiod, periodDayOfWeeks: value })
                break;
            default:
                break;
        }
    }

    useEffect(() => {

        return () => {

        }
    }, [datapreiod])

    const [Arrydataweektype, setArrydataweektype] = useState();

    const dataFechingweektype = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/common/weektype`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const data = await res.data.data
            setArrydataweektype(data)
            handelloding(false)

        } catch (error) {
            handelerrors(error)
            handelloding(false)

        }
    }


    const [arryDataDayType, setarryDataDayType] = useState();

    const dataFechingdayType = async () => {
        try {
            const res = await Axios.get(`${urldashboard}/common/dayType`, {
                headers: {
                    "Authorization": authentication,
                    "Content-Type": "application/json; charset=utf-8 "
                }
            })
            const data = await res.data.data
            setarryDataDayType(data)
            handelloding(false)

        } catch (error) {
            handelerrors(error)
            handelloding(false)

        }
    }




    useEffect(() => {
        dataFechingweektype();
        dataFechingdayType();
        return () => {

        }
    }, [])

    const handelonchengweekType = event => {

        if (datapreiod.dayType) {
            selectInputRefdayType.current.select.clearValue();
        }

        if (event) {
            handelPreiodForm({ ...datapreiod, weekType: event.value, dayType: null })
        }
        else {

        }

    }

    const handelonchengdayType = event => {
        if (datapreiod.weekType) {
            selectInputRefweekType.current.select.clearValue();
        }



        if (event) {

            handelPreiodForm({ ...datapreiod, dayType: event.value, weekType: null, periodDayOfWeeks: [] })
        }
    }


    return (
        <Accordion >
            <Card>
                <Accordion.Toggle as={Card.Header} eventKey="0"><p style={{ color: 'blue', cursor: 'pointer' }} >سفارش دوره ای است؟(در صورت دوره ای بودن کلیک کنید)</p></Accordion.Toggle>
                <Accordion.Collapse eventKey="0">
                    <Card.Body  >
                        <Form.Row>

                            <Col>
                                <InputDate label='تاریخ پایان' name='endWork' handelValue={handelValue} />
                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>هر چند روز</Form.Label>

                                    {
                                        defaultValue !== undefined ? arryDataDayType.length > 0 ?

                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                                                ref={selectInputRefdayType}
                                                defaultValue={arryDataDayType.filter(item => item.value === defaultValue)[0]}
                                                onChange={handelonchengdayType}

                                                isRtl
                                                name='dayType'
                                                options={[{
                                                    label: 'هر چند روز',
                                                    options: arryDataDayType
                                                }]}
                                            />

                                            : null :
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                                                onChange={handelonchengdayType}

                                                isRtl
                                                isClearable
                                                ref={selectInputRefdayType}
                                                name='dayType'
                                                options={[{
                                                    label: 'هر چند روز',
                                                    options: arryDataDayType
                                                }]}
                                            />
                                    }
                                </Form.Group>

                            </Col>
                            <Col>
                                <Form.Group>
                                    <Form.Label>هر چند هفته؟</Form.Label>

                                    {
                                        defaultValue !== undefined ? Arrydataweektype.length > 0 ?

                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                                                ref={selectInputRefweekType}
                                                defaultValue={Arrydataweektype.filter(item => item.value === defaultValue)[0]}
                                                onChange={handelonchengweekType}

                                                isRtl
                                                name='weekType'
                                                options={[{
                                                    label: 'هر چند هفته؟',
                                                    options: Arrydataweektype
                                                }]}
                                            />

                                            : null :
                                            <Select
                                                className="basic-single"
                                                classNamePrefix="select"
                                                styles={{ menu: provided => ({ ...provided, zIndex: 9999 }) }}
                                                onChange={handelonchengweekType}

                                                isRtl
                                                isClearable
                                                ref={selectInputRefweekType}
                                                name='weekType'
                                                options={[{
                                                    label: 'هر چند هفته؟',
                                                    options: Arrydataweektype
                                                }]}
                                            />
                                    }
                                </Form.Group>

                            </Col>
                        </Form.Row>
                        <Form.Row>
                            {datapreiod.weekType ?
                                <Col>
                                    <InputControlMulti url='/workday/dayofweekdropdown'
                                        disabled={datapreiod.weekType ? false : true}
                                        isClear={datapreiod.dayType}
                                        label="روز های هفته" name='periodDayOfWeeks' handelValue={handelValue} />
                                </Col>
                                : null
                            }
                        </Form.Row>
                    </Card.Body>
                </Accordion.Collapse>
            </Card>
        </Accordion>
    )
}
